import { render, staticRenderFns } from "./PaginatedDistributionsModal.vue?vue&type=template&id=5ff28930&scoped=true&"
import script from "./PaginatedDistributionsModal.vue?vue&type=script&lang=js&"
export * from "./PaginatedDistributionsModal.vue?vue&type=script&lang=js&"
import style0 from "./PaginatedDistributionsModal.vue?vue&type=style&index=0&id=5ff28930&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ff28930",
  null
  
)

export default component.exports